module.exports = __webpack_public_path__ + "static/media/beep.6577182b.wav";